import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { HeaderService } from '../services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagePopupService } from '../services/message-popup.service';
import { ThemeSetting } from '../objects/ThemeObject';
import { ThemeSettingService } from '../services/theme-setting.service';
import { BsModalRef, BsModalService } from '../../../node_modules/ngx-bootstrap';
import { LoginService } from '../services/login.service';
import { Globals } from '../objects/Globals';
import { TokenManager } from '../Globals';
import { Subject } from 'rxjs';
import { ConfirmationService } from '../services/confirmation.service';
import { AppSession } from '../objects/Session';
import { ToasterService } from 'angular2-toaster';
import { LoadingComponent } from '../loading/loading.component';
import { SessionTimerService } from '../services/session-timer.service';

@Component({
  selector: 'app-autologin',
  templateUrl: './autologin.component.html',
  styleUrls: ['./autologin.component.css']
})
export class AutologinComponent implements OnInit {

  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  isBusy:boolean = true;
  loaderConfig:any;

  constructor(private loginService: LoginService, 
    private globals: Globals, 
    private router:Router,
    //public bsModalRef: BsModalRef | null,
    //private modalRef: BsModalRef,
    private modalService: BsModalService,
    private tokenManager:TokenManager,
    private themeSettingService:ThemeSettingService,
    private confirmationService:ConfirmationService,
    private toasterService:ToasterService,
    private headerService: HeaderService,
    private sessionTimerService: SessionTimerService,
    private messagePopupService: MessagePopupService,
    private route:ActivatedRoute) {}

  ngOnInit() {
    var themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
    var oneTimeKey = this.route.snapshot.paramMap.get('oneTimeKey');
    var userId = this.route.snapshot.paramMap.get('userId') + "#external";
    
    this.login(userId, oneTimeKey);
  }

  login(username:string, password:string):void{
    this.isBusy = true;
    var param = [];
    param.push({ name: 'username', value: username });
    param.push({ name: 'password', value: password });

    if (this.tokenManager.retrieve("BRNHoldKey")){
      var value = this.tokenManager.retrieve("BRNHoldKey").replace(/["']/g, "");
      if (value != "null"){
        param.push({ name: 'holdKey', value: this.tokenManager.retrieve("BRNHoldKey").replace(/["']/g, "") });
      }
    }
    else if (this.tokenManager.retrieve("BRNActionKey")){
      var value = this.tokenManager.retrieve("BRNActionKey").replace(/["']/g, "");
      if (value != "null"){
        param.push({ name: 'holdKey', value: this.tokenManager.retrieve("BRNActionKey").replace(/["']/g, "") });
      }
    }

    this.loginService.login(param).subscribe(result => 
    {
      //this.bsModalRef.hide();
      if (result){
        console.log(result);
        if (result.Session){
          this.tokenManager.store("BRNHoldKey", null);
          this.redirectHome(result);
          this.isBusy = false;
        }
        else {
          setTimeout(() => {
            this.confirmationService.confirmNoInput(
              '<span class="bold">Confirmation</span>',
              result.HoldMessage,
              ["CANCEL", "OK"]).subscribe((respond) => {

                var newParam = [];
                var index = param.findIndex(x => x.name == "holdKey");
                if (index > -1){
                  newParam.push(param.find(x => x.name == "holdKey"));
                }

                if (respond.answer == "OK"){
                  var config = {
                    keyboard: false,
                    ignoreBackdropClick: true,
                    class: 'modal-dialog-centered modal-loading',
                    focus:false,
                    animated:false
                  };
                  this.isBusy = true;
                  //this.modalRef = this.modalService.show(LoadingComponent, config);

                  this.loginService.proceed(result.HoldId, true, newParam).subscribe(result => {
                    if (result){
                      this.tokenManager.store("BRNHoldKey", null);
                      this.redirectHome(result);
                      //this.modalRef.hide();
                      this.isBusy = false;

                    }
                  });
                }
                else if (respond.answer == "CANCEL"){
                  this.loginService.proceed(result.HoldId, false, newParam).subscribe(result => {
                    // if (result){
                      this.redirectHome(result);
                      this.isBusy = false;
                    // }
                  });
                }
              });  
          }, 500)
        }
      }
      else {
        this.isBusy = false;
        this.messagePopupService.popMessage("Error", "Login is not valid.", ["OK"]).subscribe((respond) => {          
          this.redirectHome(result);
        });
        //this.submitted = false;
        //this.invalid.next(true);
      }
      
    }, error => {
      this.isBusy = false;
      this.messagePopupService.popMessage("Error", "Login is not valid.", ["OK"]).subscribe((respond) => {        
        this.router.navigate(['/', 'home']);
      });
      //this.submitted = false;
      //this.tokenManager.store("BRNHoldKey", null)
    });
  }

  redirectHome(result:AppSession){
    this.globals.Session = result;
    this.loginService.setSession(result);
    this.headerService.setSessionAlive(true);
    this.sessionTimerService.startSessionTimer();
    this.router.navigate(['/', 'home']);
    document.querySelectorAll('.body-content').item(0).classList.remove('mb-login');
    document.querySelectorAll(".body-content").item(0).classList.remove('default');
    document.querySelectorAll('.navbar').item(0).classList.remove('mb-login');
    //this.invalid.next(false);
    this.globals.CardItems = [];
    this.tokenManager.delete("BRNCurrentMenu");
    if (this.globals.Session.Session.SessionId != null) {
      this.tokenManager.store('BRNSessionKey', this.globals.Session.Session.SessionId);
    }
    this.toasterService.clear();
  }
  

}
